import { useEffect, useState } from 'react';

const useIsMountedCheck = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => setIsMounted(true), []);
  return isMounted;
};

export default useIsMountedCheck;
